import Navbar from 'components/navbar';
import { Outlet } from 'react-router-dom';

const UnconstrainedForecastUpdatedHoc = () => {
  return (
    <div>
      <Navbar heading="FDP Updated - Unconstrained Forecast (15-Month)" searchComponent={<></>} progressComponent={<></>} />
      <Outlet />
    </div>
  );
};

export default UnconstrainedForecastUpdatedHoc;
